import React from 'react';

import { Helmet } from 'react-helmet';

interface Props {
  ffWidgetId?: string;
}

export const FreddyFeedback: React.FC<Props> = ({ ffWidgetId }) => {
  if (!ffWidgetId) return null;

  return (
    <Helmet>
      <script key="feedback">{`var ffWidgetId = '${ffWidgetId}';`}</script>
    </Helmet>
  );
};
